
import React from "react";
import SiteDetailPage from "@/components/sites/SiteDetailPage";

const RMRecyclage = () => {
  const services = [
    "Recyclage métaux ferreux et non ferreux",
    "Achat de métaux au cours du jour",
    "Collecte de ferraille",
    "Démantèlement d'équipements industriels",
    "Traitement de câbles électriques",
    "Valorisation de déchets métalliques"
  ];

  return (
    <SiteDetailPage
      title="RM Recyclage - Achat Métaux Cours du Jour Coren (15100)"
      description="RM Recyclage à Coren - Centre de recyclage spécialisé dans la valorisation des métaux ferreux et non ferreux dans le Cantal. Achat au cours du jour."
      proximityInfo="Centre de recyclage stratégiquement situé pour desservir efficacement l'Auvergne et les zones industrielles du Cantal, avec achat de métaux au meilleur prix."
      address="Route de Clermont Ferrand"
      postalCode="15100"
      city="Coren"
      phone="04.73.95.25.16"
      email="contactgfe@groupefabre.com"
      website="https://www.rm-recyclage.fr"
      services={services}
      coordinates={{ lat: 45.0632, lng: 2.9442 }}
      isMiniSite={true}
    />
  );
};

export default RMRecyclage;
